import React, { Component } from 'react';
import styles from './index.css';
import fonts from '../../../../iconfonts.css';
import FontAwesome from 'react-fontawesome';
import {observer} from 'mobx-react';
import {offers} from "../../../stores";


@observer
export default class Requests extends Component {

    state = { tabs:0};

    setTabs(id){
        this.setState({tabs:id})
    }

  render() {
    return (
      <div className={styles.requestTab}>
        <div className={styles.requestLists}>
          <div className={styles.button + (this.state.tabs === 0 ? ' ' + styles.active:'')} onClick={()=>this.setTabs(0)}>Нові запити</div>
          <div className={styles.button + (this.state.tabs === 1 ? ' ' + styles.active:'')} onClick={()=>this.setTabs(1)}>В роботі</div>
          <div className={styles.button + (this.state.tabs === 2 ? ' ' + styles.active:'')} onClick={()=>this.setTabs(2)}>Історія запитів</div>
        </div>
          {this.state.tabs === 0 &&
          <div className={styles.tableContainer}>
            <table className={styles.tableHeading}>
              <thead>
              <tr>
                  {/*<FontAwesome name="sort-down" />*/}
                  {/*<FontAwesome name="sort-up" />*/}
                <th>Культура&nbsp;&nbsp;&nbsp;</th>
                <th>На дату&nbsp;&nbsp;&nbsp;</th>
                <th>Тип&nbsp;&nbsp;&nbsp;</th>
                <th>Об'єм (т.)&nbsp;&nbsp;&nbsp;</th>
                <th>Вологість (%)</th>
                <th>Засміченість (%)</th>
                <th />
              </tr>
              </thead>
            </table>
            <div className={styles.tableScrollable}>
              <table>
                <tbody>
                {offers.offers.map((item,i)=>(
                    item.status === 'new' ?
                    <RequestRow {...item} num={i} key={i} />
                    : null
                    )
                )}
                </tbody>
              </table>
            </div>
          </div>
          }
          {this.state.tabs === 1 &&
          <div className={styles.tableContainer}>
            <table className={styles.tableHeading}>
              <thead>
              <tr>
                  <th>Культура&nbsp;&nbsp;&nbsp;<FontAwesome name="sort-down" /></th>
                  <th>На дату&nbsp;&nbsp;&nbsp;<FontAwesome name="sort-up" /></th>
                  <th>Тип&nbsp;&nbsp;&nbsp;<FontAwesome name="sort-down" /></th>
                  <th>Об'єм (т.)&nbsp;&nbsp;&nbsp;<FontAwesome name="sort-down" /></th>
                  <th>Залишилось (т.)</th>
                  <th>Вологість (%)</th>
                  <th style={{width:"10%"}}>Засміченість (%)</th>
                  <th/>
              </tr>
              </thead>
            </table>
            <div className={styles.tableScrollable}>
              <table>
                <tbody>
                {offers.offers.filter(item=>item.status==="inprogress").map((item,i)=>(
                            <RequestRow {...item} num={i} key={i} />
                    )
                )}
                </tbody>
              </table>
            </div>
          </div>
          }
          {this.state.tabs === 2 &&
          <div className={styles.tableContainer}>
            <table className={styles.tableHeading}>
              <thead>
              <tr>
                <th>Культура&nbsp;&nbsp;&nbsp;<FontAwesome name="sort-down" /></th>
                <th>На дату&nbsp;&nbsp;&nbsp;<FontAwesome name="sort-up" /></th>
                <th>Тип&nbsp;&nbsp;&nbsp;<FontAwesome name="sort-down" /></th>
                <th>Об'єм (т.)&nbsp;&nbsp;&nbsp;<FontAwesome name="sort-down" /></th>
                <th>Вологість (%)</th>
                <th>Засміченість (%)</th>
                <th/>
              </tr>
              </thead>
            </table>
            <div className={styles.tableScrollable}>
              <table>
                <tbody>
                {offers.offers.filter(item=>(item.status==="failed" || item.status==="success")).map((item,i)=>(
                        <RequestRow {...item} num={i} key={i} />
                    )
                )}
                </tbody>
              </table>
            </div>
          </div>
          }
      </div>
    );
  }
}

const RequestRow = (props) => {
  let cultureName = "Пшениця";
  switch (props.culture) {
    case "wheat":
      cultureName = "Пшениця";
      break;
    case "rape":
      cultureName = "Рапс";
      break;
    case "soy":
      cultureName = "Соя";
      break;
    case "sunflower":
      cultureName = "Соняшник";
      break;
    case "corn":
      cultureName = "Кукурудза";
      break;
    default:
      console.log("чё?");
  }
  let type = "Приймання";
  switch (props.type) {
    case "truck":
      type = "Вантажівка";
      break;
      case "train":
          type = "Потяг";
          break;
    default:
      type = "";
  }
  return(
    <tr>
      <td>
        <div className={styles.culture}>
          <div className={styles.cultureIcon + ' ' + styles[props.culture]}><i className={fonts[props.culture]}/></div>
          <div className={styles.cultureName}>{cultureName}</div>
        </div>
      </td>
      <td>{props.date.toLocaleDateString('ru',{ year: 'numeric', month: 'numeric', day: 'numeric' })}</td>
      <td>{type}</td>
      <td>{props.amount}</td>
        {props.status === 'inprogress' &&
        <td>
            {Math.floor(props.rem)}
        </td>
        }
      <td>{props.moisture}</td>
      <td style={{width:'10%'}}>{props.waste}</td>
      <td>
        {props.status === 'success' &&
        <div className={styles.success}>
          Запит виконано
        </div>
        }
        {props.status === 'failed' &&
        <div className={styles.failed}>
          Запит не виконано
        </div>
        }
        {props.status === 'inprogress' &&
        <div>
          Запит в процесі виконання
        </div>
        }
        {props.status === 'new' &&
        <div>
            <div onClick={()=>{
                offers.offers[props.num].setStatus('failed')
            }}
                 className={styles.button}>
                Відхилити
            </div>
          <div className={styles.button + ' ' + styles.active}
               onClick={()=>{
                   offers.offers[props.num].setStatus('inprogress',props.type, props.date, props.culture, props.amount, props.moisture, props.waste)
               }}
          >Прийняти</div>
        </div>
        }
      </td>
    </tr>
  )
};


// WEBPACK FOOTER //
// ./src/shared/components/Game/Requests/index.js